/* eslint-disable */
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import { headApi } from "utils/headApi";
import { imgApi } from "utils/imgApi";
import ListItem from "@material-ui/core/ListItem";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import Search from "@material-ui/icons/Search";
import Apps from "@material-ui/icons/Apps";
import { FaUserEdit, FaExpeditedssl, FaAddressBook } from "react-icons/fa";
import { IoMdLogOut } from "react-icons/io";
import { RiShoppingBagLine } from "react-icons/ri"
// import { MdOutlineAddChart } from "react-icons/md";
import { AiOutlineAppstoreAdd } from "react-icons/ai";
import CustomInput from "components/CustomInput/CustomInput.js";
import CustomDropdown from "components/CustomDropdown/CustomDropdown.js";
import Button from "components/CustomButtons/Button.js";

import styles from "assets/jss/material-kit-pro-react/components/headerLinksStyle.js";
import navbarsStyle from "assets/jss/material-kit-pro-react/views/componentsSections/navbarsStyle.js";

const useStyles = makeStyles(styles);
const useStyle = makeStyles(navbarsStyle);

export default function HeaderLinks(props) {
  const [bangle, setbangle] = React.useState([]);
  const [earing, setEaring] = React.useState([]);
  const [ring, setRing] = React.useState([]);
  const [watch, setWatch] = React.useState([]);
  const [kada, setKada] = React.useState([]);
  const [cardList, setCardList] = React.useState([]);

  // const [addCart, setAddCart] = React.useState([])
  // const easeInOutQuad = (t, b, c, d) => {
  //   t /= d / 2;
  //   if (t < 1) return (c / 2) * t * t + b;
  //   t--;
  //   return (-c / 2) * (t * (t - 2) - 1) + b;
  // };

  // const smoothScroll = (e, target) => {
  //   if (window.location.pathname === "/sections") {
  //     var isMobile = navigator.userAgent.match(
  //       /(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i
  //     );
  //     if (isMobile) {
  //       // if we are on mobile device the scroll into view will be managed by the browser
  //     } else {
  //       e.preventDefault();
  //       var targetScroll = document.getElementById(target);
  //       scrollGo(document.documentElement, targetScroll.offsetTop, 1250);
  //     }
  //   }
  // };
  // const scrollGo = (element, to, duration) => {
  //   var start = element.scrollTop,
  //     change = to - start,
  //     currentTime = 0,
  //     increment = 20;

  //   var animateScroll = function () {
  //     currentTime += increment;
  //     var val = easeInOutQuad(currentTime, start, change, duration);
  //     element.scrollTop = val;
  //     if (currentTime < duration) {
  //       setTimeout(animateScroll, increment);
  //     }
  //   };
  //   animateScroll();
  // };
  var onClickSections = {};

  const { dropdownHoverColor } = props;
  const classes = useStyles();
  const classe = useStyle();
  const history = useHistory();

  const date = Intl.DateTimeFormat("fr-CA", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
  })
    .format(new Date())
    .replaceAll("/", "-");

  const activeSession = sessionStorage.getItem("sessionData");

  const userObj = JSON.parse(sessionStorage.getItem("sessionData"));

  // const headApi = `https://api.bangles.org.in/api/rest`;

  // async function getUsers() {
  //     const api = `https://secure.mybangles24.com/api/rest/categories`;
  //     const result = await fetch(api);
  //     const getResult = await result.json();
  //     // console.log(getResult.CategoriesData);
  //     setCategory(getResult.CategoriesData.filter(item => item.description !== "My Offer"));
  //     let catId = getResult.CategoriesData.find((d) => d?.id);
  //     const get = `https://www.secure.mybangles24.com/api/rest/categories/size-mm?catid=${catId.id}&userid=1`;
  //     const results = await fetch(get);
  //     const ress = await results.json();
  //     setCatList(ress.cat1SizemmData);
  // }

  // useEffect(() => {
  //     getUsers();
  // }, []);

  async function getList() {
    const get = headApi + `/user/${userObj && userObj.mobile ? userObj.mobile : "+919051979509"}`;
    const results = await fetch(get);
    const res = await results.json();
    // if(res.error === "true"){
    //   console.clear()
    // }
    const list = headApi + `/cart/byInterval?userid=1&clientid=${res.id}`
    const result = await fetch(list);
    const data = await result.json();
    // if(data.error === "true"){
    //   console.clear()
    // }
    // console.log(data && data.CartData ? data.CartData : "No Data Found");
    setCardList(data);
  }

  useEffect(() => {
    getList();
  }, []);

  async function getBangle() {
    const results = await fetch(
      headApi + `/category/size-mm/byProducts?catid=11&userid=1`
    );
    const response = await results.json();
    setbangle(response.cat1SizemmData);
  }

  useEffect(() => {
    getBangle();
  }, []);

  async function getEaring() {
    const results1 = await fetch(headApi + `/category/size-mm/byProducts?catid=12&userid=1`);
    const response = await results1.json();
    setEaring(response.cat1SizemmData);
  }

  useEffect(() => {
    getEaring();
  }, []);

  async function getRing() {
    const results2 = await fetch(headApi + `/category/size-mm/byProducts?catid=13&userid=1`);
    const response2 = await results2.json();
    setRing(response2.cat1SizemmData);
  }

  useEffect(() => {
    getRing();
  }, []);

  async function getWatch() {
    const results3 = await fetch(headApi + `/category/size-mm/byProducts?catid=14&userid=1`);
    const response3 = await results3.json();
    setWatch(response3.cat1SizemmData);
  }

  useEffect(() => {
    getWatch();
  }, []);

  async function getKada() {
    const results4 = await fetch(headApi + `/category/size-mm/byProducts?catid=15&userid=1`);
    const response4 = await results4.json();
    setKada(response4.cat1SizemmData);
  }

  useEffect(() => {
    getKada();
  }, []);

  const handleLogOut = () => {
    const finalURL = headApi + `/user/logout/${userObj && userObj.mobile
      }`;
    fetch(finalURL, {
      method: "PUT",
      headers: {
        "content-type": "application/json",
        accept: "application/json",
      },
    })
      .then((response) => response.json())
      .then((response) => {
        // console.log(response);
        if(response.message === "Logout Successfully"){
          sessionStorage.removeItem("sessionData");
        history.push("/")
        window.location.reload(false);
        }
      })
  };

  return (
    <>
      <List className={classes.list + " " + classes.mlAuto}>
        {/* {" "}
        <div className={classe.mlAuto}>
          <CustomInput
            // black
            white
            inputRootCustomClasses={classe.inputRootCustomClasses}
            formControlProps={{
              className: classe.formControl,
            }}
            inputProps={{
              placeholder: "Search",
              inputProps: {
                "aria-label": "Search",
                className: classe.searchInput,
              },
            }}
          />
          <Button color="white" justIcon round>
            <Search className={classe.searchIcon} />
          </Button>
        </div>{" "} */}
        {/* {category && category.map((cat) => (
                    <ListItem className={classes.listItem} key={cat.id}>
                        <CustomDropdown
                            noLiPadding
                            navDropdown
                            hoverColor={dropdownHoverColor}
                            buttonText={cat.description}
                            buttonProps={{
                                className: classes.navLink,
                                color: "transparent",
                            }}
                            buttonIcon={Apps}
                            dropdownList=
                        {catList && catList.map((x) => (
                        <Link to="/" className={classes.dropdownLink} key={x.id}>
                            {x.description}
                        </Link>
                        ))}
                        />
                    </ListItem>
                ))} */}
        <ListItem className={classes.listItem}>
          <CustomDropdown
            noLiPadding
            navDropdown
            hoverColor={dropdownHoverColor}
            buttonText="Bangles"
            buttonProps={{
              className: classes.navLink,
              color: "transparent",
            }}
            buttonIcon={Apps}
            dropdownList={
              bangle &&
              bangle.map((x) => (
                // /bangles-size-mm-list?cat=bangles&size=102
                <Link
                  to={`/bangles-size-mm-list?catdesc=Bangles&cat1desc=${x.description}&Plating=Gold%20Plating`}
                  className={classes.dropdownLink}
                  key={x.id}
                >
                  {x.description}
                </Link>
              ))
            }
          />
        </ListItem>
        <ListItem className={classes.listItem}>
          <CustomDropdown
            noLiPadding
            navDropdown
            hoverColor={dropdownHoverColor}
            buttonText="Earings"
            buttonProps={{
              className: classes.navLink,
              color: "transparent",
            }}
            buttonIcon={Apps}
            dropdownList=
            {earing && earing.map((x) => (
              <Link to={`/bangles-size-mm-list?catdesc=Earrings&cat1desc=${x.description}&Plating=Gold%20Plating`} className={classes.dropdownLink} key={x.id}
                
              >
                {x.description}
              </Link>
            ))}
          />
        </ListItem>
        <ListItem className={classes.listItem}>
          <CustomDropdown
            noLiPadding
            navDropdown
            hoverColor={dropdownHoverColor}
            buttonText="Finger Ring"
            buttonProps={{
              className: classes.navLink,
              color: "transparent",
            }}
            buttonIcon={Apps}
            dropdownList=
            {ring && ring.map((x) => (
              <Link to={`/bangles-size-mm-list?catdesc=Finger Ring&cat1desc=${x.description}&Plating=Gold%20Plating`} className={classes.dropdownLink} key={x.id}
                
              >
                {x.description}
              </Link>
            ))}
          />
        </ListItem>
        <ListItem className={classes.listItem}>
          <CustomDropdown
            noLiPadding
            navDropdown
            hoverColor={dropdownHoverColor}
            buttonText="Watch"
            buttonProps={{
              className: classes.navLink,
              color: "transparent",
            }}
            buttonIcon={Apps}
            dropdownList=
            {watch && watch.map((x) => (
              <Link to={`/bangles-size-mm-list?catdesc=Watch&cat1desc=${x.description}&Plating=Gold%20Plating`} className={classes.dropdownLink} key={x.id}
                
              >
                {x.description}
              </Link>
            ))}
          />
        </ListItem>
        <ListItem className={classes.listItem}>
          <CustomDropdown
            noLiPadding
            navDropdown
            hoverColor={dropdownHoverColor}
            buttonText="Punjabi kada"
            buttonProps={{
              className: classes.navLink,
              color: "transparent",
            }}
            buttonIcon={Apps}
            dropdownList=
            {kada && kada.map((x) => (
              <Link to={`/bangles-size-mm-list?catdesc=Punjabi kada&cat1desc=${x.description}&Plating=Gold%20Plating`} className={classes.dropdownLink} key={x.id}
                
              >
                {x.description}
              </Link>
            ))}
          />
        </ListItem>
        {!activeSession ? (
          ""
        ) : (
          <span>
            {cardList && cardList.CartData ?
              <ListItem className={classes.listItem}>
                <CustomDropdown
                  noLiPadding
                  navDropdown
                  hoverColor={dropdownHoverColor}
                  buttonText="Cart"
                  buttonProps={{
                    className: classes.navLink,
                    color: "transparent",
                  }}
                  buttonIcon={ShoppingCartIcon}
                  dropdownList={[
                    <Link
                      to="/add-cart"
                      // to={`/cart?byuserid=919967457786&clientid=${
                      //   userObj && userObj.mobile.slice(1)
                      // }`}
                      className={classes.dropdownLink}
                    >
                      <AiOutlineAppstoreAdd className={classes.dropdownIcons} /> My Cart
                    </Link>,
                  ]}
                />
              </ListItem>
              : ""}
            <ListItem className={classes.listItem}>
              <CustomDropdown
                noLiPadding
                navDropdown
                hoverColor={dropdownHoverColor}
                buttonText="Section"
                buttonProps={{
                  className: classes.navLink,
                  color: "transparent",
                }}
                buttonIcon={Apps}
                dropdownList={[
                  <Link to="/edit-profile" className={classes.dropdownLink}>
                    <FaUserEdit className={classes.dropdownIcons} /> Edit
                    Profile
                  </Link>,
                  <Link to="/edit-password" className={classes.dropdownLink}>
                    <FaExpeditedssl className={classes.dropdownIcons} />{" "}
                    Generate Password
                  </Link>,
                  <Link to="/edit-address" className={classes.dropdownLink}>
                    <FaAddressBook className={classes.dropdownIcons} /> Address
                  </Link>,
                  <Link to="/my-order" className={classes.dropdownLink}>
                    <RiShoppingBagLine className={classes.dropdownIcons} /> My Order
                  </Link>,
                  <>{activeSession ? <Link to="" className={classes.dropdownLink} onClick={handleLogOut}>
                    <IoMdLogOut className={classes.dropdownIcons} /> Log Out
                  </Link> : ""}</>
                ]}
              />
            </ListItem>
          </span>
        )}
      </List>
    </>
  );
}

HeaderLinks.defaultProps = {
  hoverColor: "primary",
};

HeaderLinks.propTypes = {
  dropdownHoverColor: PropTypes.oneOf([
    "dark",
    "primary",
    "info",
    "success",
    "warning",
    "danger",
    "rose",
  ]),
};
